import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { AuthLayout } from "./Login";
import { Button, ErrorBox, Field, Input } from "../components/kd";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await api.post("/auth/passwort-vergessen", { email }); setDone(true); } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <AuthLayout>
      <h1 className="mb-2">Passwort vergessen</h1>
      {done ? (
        <p data-testid="forgot-done">Falls ein Konto mit dieser E-Mail-Adresse existiert, haben wir Ihnen einen Link zum Zurücksetzen gesendet. Der Link ist 1 Stunde gültig.</p>
      ) : (
        <form onSubmit={submit}>
          <p className="mb-5 text-text-muted">Wir senden Ihnen einen Link zum Festlegen eines neuen Passworts.</p>
          <ErrorBox>{err}</ErrorBox>
          <Field label="E-Mail-Adresse" required htmlFor="fe"><Input id="fe" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" /></Field>
          <Button type="submit" className="w-full" loading={busy} data-testid="forgot-submit-button">Link anfordern</Button>
        </form>
      )}
      <p className="mt-4 text-center"><Link to="/login">Zur Anmeldung</Link></p>
    </AuthLayout>
  );
}

export function ResetPassword() {
  const [sp] = useSearchParams();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const invite = sp.get("einladung");
  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setErr("");
    if (pw.length < 12) return setErr("Das Passwort muss mindestens 12 Zeichen lang sein.");
    if (pw !== pw2) return setErr("Die Passwörter stimmen nicht überein.");
    setBusy(true);
    try { await api.post("/auth/passwort-zuruecksetzen", { token: sp.get("token") || "", passwort: pw }); setDone(true); } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <AuthLayout>
      <h1 className="mb-2">{invite ? "Passwort festlegen" : "Neues Passwort"}</h1>
      {done ? (
        <p data-testid="reset-done">Ihr Passwort wurde gespeichert. <Link to="/login">Jetzt anmelden</Link></p>
      ) : (
        <form onSubmit={submit}>
          <ErrorBox testid="reset-error">{err}</ErrorBox>
          <Field label="Neues Passwort" required htmlFor="p1" hint="Mindestens 12 Zeichen"><Input id="p1" type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" /></Field>
          <Field label="Passwort wiederholen" required htmlFor="p2"><Input id="p2" type="password" autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm-input" /></Field>
          <Button type="submit" className="w-full" loading={busy} data-testid="reset-submit-button">Passwort speichern</Button>
        </form>
      )}
    </AuthLayout>
  );
}
